import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { FaHome, FaTruck, FaBox, FaUser, FaWallet } from "react-icons/fa";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const sidebarRef = useRef(null);

  const handleLinkClick = () => {
    toggleSidebar(false);
  };

  return (
    <aside
      ref={sidebarRef}
      className={`fixed top-0 left-0 h-full bg-white border-r shadow-md transition-transform transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } w-64 z-40`}
    >
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-lg font-semibold text-gray-800">Menu</h2>

        <button
          className="text-gray-600 hover:text-red-500 text-lg"
          onClick={() => toggleSidebar(false)}
        >
          ✕
        </button>
      </div>

      {/* Menu */}
      <ul className="mt-4 space-y-1">
        <li>
          <Link
            to="/"
            onClick={handleLinkClick}
            className="flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition"
          >
            <FaHome size={18} />
            <span className="font-medium">Home</span>
          </Link>
        </li>

        <li>
          <Link
            to="/order-status"
            onClick={handleLinkClick}
            className="flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition"
          >
            <FaTruck size={18} />
            <span className="font-medium">Order Status</span>
          </Link>
        </li>

        <li>
          <Link
            to="/products"
            onClick={handleLinkClick}
            className="flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition"
          >
            <FaBox size={18} />
            <span className="font-medium">Products</span>
          </Link>
        </li>

        <li>
          <Link
            to="/profile"
            onClick={handleLinkClick}
            className="flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition"
          >
            <FaUser size={18} />
            <span className="font-medium">Profile</span>
          </Link>
        </li>

        <li>
          <Link
            to="/wallet"
            onClick={handleLinkClick}
            className="flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition"
          >
            <FaWallet size={18} />
            <span className="font-medium">Wallet</span>
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
